import * as React from "react";
import classnames from "classnames";
import Step from "../Step/WizardProgress/Step/Step.js";
/* empty css                    */
const getStatus = (active, index, skip) => {
  if (active === index) {
    return "active";
  } else if (skip) {
    return "skip";
  } else if (active > index) {
    return "done";
  } else {
    return "open";
  }
};
const WizardProgress = ({
  className,
  steps,
  active,
  withSeparators = false,
  labelStyle,
  onClick,
  skipSteps,
  disableSteps,
  ...rest
}) => {
  return /* @__PURE__ */ React.createElement(
    "ol",
    {
      ...rest,
      className: classnames("wizard-progress", className, {
        "wizard-progress--with-inline-labels": labelStyle === "inline",
        "wizard-progress--with-separators": withSeparators && labelStyle !== "inline"
      })
    },
    steps.map((step, index) => {
      const isSkip = skipSteps?.includes(index);
      const isDisabled = disableSteps?.includes(index);
      return /* @__PURE__ */ React.createElement("li", { className: "wizard-progress__item", key: step }, /* @__PURE__ */ React.createElement(
        Step,
        {
          index,
          number: index + 1,
          label: step,
          className: classnames({
            "wizard-progress__step--with-spacing": !withSeparators && labelStyle === "hidden"
          }),
          disabled: isSkip || isDisabled || false,
          hideLabel: labelStyle === "hidden",
          status: getStatus(active, index, isSkip || false),
          onClick,
          "data-t": `wizardStep${index + 1}`
        }
      ));
    })
  );
};
export {
  WizardProgress as default
};
//# sourceMappingURL=WizardProgress.js.map
